import { Component, Input } from '@angular/core';
import { DocsParam } from '../../../data/docs-api-data';

@Component({
  selector: 'app-docs-param-list',
  standalone: false,
  templateUrl: './docs-param-list.html',
  styleUrl: './docs-param-list.scss',
})
export class DocsParamList {
  @Input() items: DocsParam[] = [];

  private expanded = new Set<string>();

  get allExpanded(): boolean {
    return this.items.length > 0 && this.expanded.size === this.items.length;
  }

  isExpanded(name: string): boolean {
    return this.expanded.has(name);
  }

  toggle(name: string): void {
    if (this.expanded.has(name)) {
      this.expanded.delete(name);
    } else {
      this.expanded.add(name);
    }
  }

  toggleAll(): void {
    this.expanded = this.allExpanded ? new Set() : new Set(this.items.map(p => p.name));
  }
}
